/** @format */

import React, { useState, useEffect } from "react";
import "./index.scss";
import SiTable from "../../core/table";
import { getHeaderConfig, getMobileHeaderConfig } from "./config";
import { invokeApi, HTTP_METHODS } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { useNavigate } from "react-router-dom";
import { getOfflineData } from "../../utils/offline-services";
import { toast } from "react-toastify";
import CustomModal from "../../core/modal";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Select from "react-select";
import Checkbox from "@mui/material/Checkbox";
import { STATES, INDUSTRY } from "./helper";
import { Add, ArrowForward } from "@mui/icons-material";
import CustomButtonComponent from "../../core/custom-button";
import CustomTable from "../../core/custom-table";
import OEMFilters from "./oem-filters";
import { PAGE_LIMIT } from "../../utils";
import { FormGroup, FormControlLabel } from "@mui/material";

const Oems = () => {
  const [addOem, setAddOem] = useState(false);
  const [name, setName] = useState("");
  const [realName, setRealName] = useState("");
  const [code, setCode] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [country, setCountry] = useState("");
  const [password, setPassword] = useState("");
  const [district, setDistrict] = useState("");
  const [state, setState] = useState("");
  // const [industry, setIndustry] = useState("");
  const [Oems, setOems] = useState({});
  const [isAdmin, setIsAdmin] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [oemNames, setOemNames] = useState([]);
  const [mainFilters, setMainFilters] = useState({});
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");
  const [filters, setFilters] = useState({
    page: 1,
    limit: PAGE_LIMIT,
    sortBy: "-createdAt",
  });

  const navigate = useNavigate();

  useEffect(() => {
    if (!getOfflineData("user")) {
      navigate("/");
    } else {
      loadData(filters);
      loadNames();
    }
  }, []);
  const addOemFormHandler = () => {
    setAddOem(true);
  };
  const addNameHandler = (event) => {
    setName(event);
  };
  const addCodeHandler = (event) => {
    setCode(event.target.value);
  };
  const addEmailHandler = (event) => {
    setEmail(event.target.value);
  };
  const addPasswordHandler = (event) => {
    setPassword(event.target.value);
  };
  const addPhoneNumberHandler = (event) => {
    const value = event.target.value;
    setPhoneNumber(value);
    const phoneRegex = /^[0-9]{10}$/;

    if (value && !phoneRegex.test(value)) {
      setError(true);
      setHelperText("Phone number must be 10 digits");
    } else {
      setError(false);
      setHelperText("");
    }
  };
  const addAddressHandler = (event) => {
    setAddress(event.target.value);
  };
  const addStateHandler = (event) => {
    setState(event.label);
  };
  const addDistrictHandler = (event) => {
    setDistrict(event.target.value);
  };
  const addCountryHandler = (event) => {
    setCountry(event.target.value);
  };
  // const addIndustryHandler = (event) => {
  //   setIndustry(event.label);
  // };
  const payload = {
    name: realName || name.name,
    code: code,
    email: email,
    oemNameId: name.id,
    password: password,
    admin: isAdmin,
    address: {
      line1: address,
      district: district,
      state: state,
      country: country,
    },
    phoneNumber: phoneNumber,
  };
  //Show All Oems
  const loadData = (params) => {
    invokeApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.OEMS}`, null, params)
      .then((response) => {
        if (response) {
          setOems(response);
        }
      })
      .catch((err) => console.error(err));
  };

  const loadNames = () => {
    invokeApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.OEM_NAMES}`, null)
      .then((response) => {
        if (response) {
          setOemNames(response);
        }
      })
      .catch((err) => console.error(err));
  };
  //Add New Oem
  const formSubmitHandler = () => {
    invokeApi(HTTP_METHODS.POST, `${HOSTNAME}${REST_URLS.OEMS}`, payload, {
      active: true,
    })
      .then((response) => {
        if (response.message) {
          toast.error(response.message);
        } else {
          loadData(filters);
          setName("");
          setCode("");
          setEmail("");
          setPassword("");
          setAddress("");
          setDistrict("");
          setState("");
          setCountry("");
          setRealName("");
          setPhoneNumber("");
          setError(false);
          setHelperText("");
          setIsAdmin(false);
          setAddOem(false);
        }
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    if (Oems?.totalPages !== 0 && Oems?.totalPages < Oems?.page) {
      setFilters({ ...filters, page: 1 });
      loadData({
        ...filters,
        ...mainFilters,
        page: 1,
      });
    }
  }, [Oems]);
  return (
    <>
      <div className="page-body">
        <div className="create-con">
          <div>
            <p className="tab-name">Setup</p>
            <p className="section-name">Oems</p>
          </div>
          <CustomButtonComponent
            variant="contained"
            color="primary"
            onClick={addOemFormHandler}
          >
            Add Oem
          </CustomButtonComponent>
        </div>

        <div className="si-hide-mobile">
          <CustomTable
            header={getHeaderConfig(loadData)}
            data={Oems.results || []}
            pageCount={Oems.totalPages}
            onChange={(page) => {
              setFilters({
                ...filters,
                page,
              });
              loadData({
                ...filters,
                ...mainFilters,
                page,
              });
            }}
            filterCom={
              <OEMFilters
                loadData={loadData}
                setMainFilters={setMainFilters}
                filter={filters}
              />
            }
          />
        </div>
        {addOem && (
          <CustomModal
            title="New Oem"
            contentClassName="add-oem"
            onClose={() => setAddOem(false)}
          >
            <Box
              sx={{
                width: 500,
                maxWidth: "100%",
              }}
            >
              <div className="oem-drop-downs-c">
                <Select
                  value={name}
                  classNamePrefix="si-select"
                  options={oemNames}
                  onChange={addNameHandler}
                  getOptionLabel={(op) => op.name}
                  getOptionValue={(op) => op.id}
                  placeholder={state !== "" ? state : "Organization Name"}
                />
                <div></div>
              </div>
              <TextField
                fullWidth
                id="realName"
                label="Name"
                sx={{ mb: 1 }}
                rows={4}
                onChange={(e) => setRealName(e.target.value)}
                value={realName}
                size="small"
              />
              <TextField
                fullWidth
                id="code"
                label="Code"
                sx={{ mb: 1 }}
                rows={4}
                onChange={addCodeHandler}
                value={code}
                size="small"
              />

              <TextField
                fullWidth
                id="email"
                label="Email"
                sx={{ mb: 1 }}
                onChange={addEmailHandler}
                value={email}
                type="email"
                size="small"
              />
              <TextField
                fullWidth
                id="password"
                label="Password"
                sx={{ mb: 1 }}
                onChange={addPasswordHandler}
                value={password}
                type="password"
                size="small"
              />
              <TextField
                fullWidth
                id="phoneNumber"
                label="Phone Number"
                sx={{ mb: 1 }}
                onChange={addPhoneNumberHandler}
                value={phoneNumber}
                type="number"
                size="small"
                error={error}
                helperText={helperText}
              />
              <TextField
                fullWidth
                id="address"
                label="Address"
                sx={{ mb: 1 }}
                rows={4}
                onChange={addAddressHandler}
                value={address}
                size="small"
              />
              <TextField
                fullWidth
                id="district"
                label="District"
                sx={{ mb: 1 }}
                rows={4}
                onChange={addDistrictHandler}
                value={district}
                size="small"
              />

              <TextField
                id="country"
                fullWidth
                label="Country"
                sx={{ mb: 1 }}
                rows={4}
                onChange={addCountryHandler}
                value={country}
                size="small"
              />
              <div className="oem-drop-downs-c">
                {/* <Select
                  value={industry}
                  classNamePrefix="si-select"
                  options={INDUSTRY}
                  onChange={addIndustryHandler}
                  placeholder={industry !== "" ? industry : "Domain"}
                /> */}

                <Select
                  value={state}
                  classNamePrefix="si-select"
                  options={STATES}
                  onChange={addStateHandler}
                  placeholder={state !== "" ? state : "State"}
                />

                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isAdmin}
                        onChange={(e) => {
                          setIsAdmin(e.target.checked);
                        }}
                      />
                    }
                    label="Is Admin"
                  />
                </FormGroup>
              </div>

              <Stack
                direction="row"
                spacing={2}
                sx={{ mt: 2, ml: 0, justifyContent: "flex-end" }}
              >
                <CustomButtonComponent
                  variant="outlined"
                  color="error"
                  fullWidth
                  onClick={() => {
                    setAddOem(false);
                  }}
                >
                  Cancel
                </CustomButtonComponent>
                <CustomButtonComponent
                  variant="contained"
                  fullWidth
                  color="primary"
                  onClick={formSubmitHandler}
                >
                  Save
                </CustomButtonComponent>
              </Stack>
            </Box>
          </CustomModal>
        )}
      </div>
    </>
  );
};

export default Oems;
